<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">{{ hotel.name }}</h1>
        <star-rating
            :rating="hotel.rating"
            :read-only="true"
            :star-size="22"
            :show-rating="false"
            :inline="true"
            :rounded-corners="true"
            :increment="0.5"
            active-color="#eb9514"
            inactive-color="#d1d1d1"
        ></star-rating>
      </app-cells>
      <app-tabs :tabs="tabs_to_show" />
      <transition name="fade" mode="out-in">
        <router-view :hotel="hotel" @update="getHotelData" />
      </transition>
    </template>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import AppTabs from '@/components/AppTabs.vue'
import { getHotelDetail } from '@/http'

export default {
  name: 'HotelsDatabaseDetailLayout',
  components: { AppTabs, StarRating },
  data() {
    return {
      tabs: [
        { name: 'hotels-database-general', label: 'General', roles: ['general_manager', 'reservation_supervisor', 'reservation_manager', 'reservation_assistant', 'sales_manager'] },
        { name: 'hotels-database-settings', label: 'Settings', roles: ['general_manager'] },
      ],
      tabs_to_show: [],
      hotel: {},
      is_loaded: false,
    }
  },
  created() {
    document.title = `Database (ID: ${this.$route.params.id}) | Altezza Board`
    const tabs = []
    this.tabs.forEach(item => {
      if (!item.roles.length) {
        tabs.push(item)
        return
      }
      item.roles.forEach(role => {
        if (this.$store.state.userGroups.some(groupRole => groupRole.code === role)) tabs.push(item)
      })
    })
    this.tabs_to_show = tabs
    this.getHotelData()
  },
  methods: {
    getHotelData() {
      getHotelDetail(this.$route.params.id)
        .then(res => {
          this.hotel = res.data
          this.is_loaded = true
        })
    }
  }
}
</script>
<style lang="sass">
.vue-star-rating
  transform: translateY(2px)
</style>
